import React, { useState } from "react";
import { Button, Typography, TableCell, TableRow, TextField, Tooltip } from "@mui/material";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import MultiLineCreatableSelect from "./MultiLineCreatableSelect";
import CancelIcon from "@mui/icons-material/Cancel";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import PlaylistAddCircleIcon from "@mui/icons-material/PlaylistAddCircle";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import InfoIcon from "@mui/icons-material/Info";
import CheckIcon from "@mui/icons-material/Check";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
import InsertPhotoOutlinedIcon from "@mui/icons-material/InsertPhotoOutlined";
import DialogBox from "../DialogBox/DialogBox";
import { toast } from "react-toastify";
import { AddPhotoAlternateOutlined } from "@mui/icons-material";

// Prevents individual rows from re-rendering when sibling rows change
const HseObservationRow = React.memo(
  ({
    observation,
    index,
    tableType,
    rowDd,
    isRowInSelected,
    isEditing,
    currentEditedRow,
    selectedObservations,
    safeGroupedObservations,
    selectedObservation,
    openDialog,
    dialog,
    allData,
    criticalityOptionList,
    statusOptionList,
    customSelectStylesCreatable,
    handleCellEdit,
    handleDeleteRow,
    handleSaveRowBatch,
    handleEditNewRow,
    handleEditFieldFocus,
    handleEditFieldBlur,
    handleOpenImageDialog,
    handleCloseImageDialog,
    handleRemoveImage,
    handleImageUpload,
    handleDialogBoxObservation,
    getAreaOptions,
    getEquipmentOptions,
    getCategoryOptions,
    getCheckpointOptions,
    getObservationVariants,
    isFieldDisabled,
    populateHseCategoryList,
    populateCheckpointList,
    populateCriticalityList,
    populateStatusList,
    populateLegalReferenceList,
    debouncedObservationEdit,
    debouncedRecommendationEdit,
    debouncedLegalReferenceEdit,
    setIsEditing,
    setCurrentEditedRow,
    setIsReportEdited,
    setSelectedImage,
    setIsEditAreaDropdownOpen,
    setIsEditEquipmentDropdownOpen,
    setIsEditCategoryDropdownOpen,
    setIsEditCheckpointDropdownOpen,
    setIsEditCriticalityDropdownOpen,
    setIsEditStatusDropdownOpen,
    setIsEditObservationDropdownOpen,
    setIsEditRecommendationsDropdownOpen,
    editAreaSelectRef,
    editCheckpointSelectRef,
    editCriticalitySelectRef,
    editStatusSelectRef,
    measureRef,
    dataIndex,
    bulkUploadedImages,
    handleUnassignBulkImageFromRow,
    handleAssignBulkImageToRow,
    handleEmptyCheck,
    handleOpenGallery,
    emptyFieldFound,
  }) => {
    const rowClassName =
      isEditing &&
        isRowInSelected &&
        currentEditedRow !== observation.sr_no && 
        currentEditedRow !== observation.id
        ? "odd-row"
        : "even-row";
    return (
      <TableRow
        key={`${observation.table_type}-${observation.area
          }-${observation.sr_no || observation.id}`}
        // measureRef lets @tanstack/react-virtual measure this row's real
        // height; data-index tells it which row this is. aria-rowindex keeps the
        // true (1-based, header-offset) position for screen readers even though
        // off-screen rows are not in the DOM under virtualization.
        ref={measureRef}
        data-index={dataIndex}
        aria-rowindex={index + 2}
        className={rowClassName}
        style={{
          ...(observation.variant === true ? { backgroundColor: "#f2f2f2" } : {}),
        }}
      >
        <TableCell>{index + 1}</TableCell>


        {/* area */}
        <TableCell
          className="editable-cell"
          style={{ height: "100px" }}
        >
          <div
            className="cell-content"
            style={{
              color:
                isEditing &&
                  currentEditedRow !==
                  observation.sr_no

                  ? "grey"
                  : "black",
            }}
          >
            {/* <CreatableSelect
                                        styles={customSelectStylesCreatable}
                                        placeholder="Area"
                                        options={areaList.map((area) => ({ label: area, value: area }))}
                                        defaultValue={{
                                          label: observation.area,
                                          value: observation.area,
                                        }}
                                        isSearchable
                                        isClearable
                                        onChange={(e) =>
                                          handleCellEdit(
                                            e,
                                            index,
                                            "area",
                                            observation.area,
                                            observation
                                          )
                                        }
                                        isDisabled={
                                          isEditing &&
                                          currentEditedRow !==
                                          observation.sr_no


                                        }
                                      /> */}
            <MultiLineCreatableSelect
              ref={editAreaSelectRef}
              placeholder="Area"
              multiline={false}
              options={getAreaOptions(observation.table_type)}
              value={observation.area || "N/A"}
              clearAriaLabel="Clear Area and delete row"
              onBeforeClear={() => {
                const isCurrentEditedRow =
                  isEditing &&
                  (currentEditedRow === observation.sr_no ||
                    currentEditedRow === observation.id);
                if (!isCurrentEditedRow) {
                  return true;
                }
                const confirmed = window.confirm(
                  "Clearing Area will delete this observation row. Continue?"
                );
                if (!confirmed) {
                  return false;
                }
                handleDeleteRow(
                  observation.table_type,
                  observation.area,
                  observation.sr_no || observation.id,
                  true
                );
                return false;
              }}
              // onChange={(val) => handleCellEdit(
              //   { label: val, value: val },
              //   index,
              //   "area",
              //   observation.area,
              //   observation
              // )}
              onSelect={(val) => handleCellEdit(
                { label: val, value: val },
                index,
                "area",
                observation.area,
                observation
              )}
              onFocus={() => handleEditFieldFocus(observation.sr_no, "area")}
              onBlur={() => handleEditFieldBlur(observation.sr_no, "area")}
              onMenuOpen={() => {
                setIsEditAreaDropdownOpen(true);
              }}
              onMenuClose={() => setIsEditAreaDropdownOpen(false)}
              menuPortalTarget={document.body}
              isDisabled={isFieldDisabled(observation) || observation.variant === true}
              containerClasses={!observation.area || !observation.area.trim() ? "error-input" : ""}
            />
          </div>
        </TableCell>

        {/* Equipment */}
        <TableCell
          className="editable-cell"
          style={{ height: "100px" }}
        >
          <div
            className="cell-content"
            style={{
              color:
                isEditing &&
                  currentEditedRow !==
                  observation.sr_no
                  ? "grey"
                  : "black",
            }}
          >
            <MultiLineCreatableSelect
              placeholder="Equipment"
              multiline={false}
              options={getEquipmentOptions(observation.area || "")}
              value={observation.equipment || "N/A"}
              // onChange={(val) => {
              //   const proceed = handleCellEdit(
              //     { label: val, value: val },
              //     index,
              //     "equipment",
              //     observation.equipment,
              //     observation
              //   );
              //   if (proceed !== false && val) {
              //     populateHseCategoryList(val, "equipment", observation.area);
              //   }
              // }}
              onSelect={(val) => {
                const proceed = handleCellEdit(
                  { label: val, value: val },
                  index,
                  "equipment",
                  observation.equipment,
                  observation
                );
                if (proceed !== false && val) {
                  populateHseCategoryList(val, "equipment", observation.area);
                }
              }}
              onFocus={() => handleEditFieldFocus(observation.sr_no, "equipment")}
              onBlur={() => handleEditFieldBlur(observation.sr_no, "equipment")}
              onMenuOpen={() => {
                setIsEditEquipmentDropdownOpen(true);
              }}
              onMenuClose={() => setIsEditEquipmentDropdownOpen(false)}
              menuPortalTarget={document.body}
              isDisabled={isFieldDisabled(observation) || observation.variant === true}
              containerClasses={observation?.emptyFields?.length && observation.emptyFields.includes("Equipment") ? "error-input" : ""}
            />
          </div>
        </TableCell>

        {/* Category */}
        <TableCell
          className="editable-cell"
          style={{ height: "100px" }}
        >
          <div
            className="cell-content"
            style={{
              color:
                isEditing &&
                  currentEditedRow !== observation.sr_no
                  ? "grey"
                  : "black",
            }}
          >
            <MultiLineCreatableSelect
              placeholder="Category"
              multiline={false}
              options={getCategoryOptions(observation.area, observation.equipment)}
              value={observation.category || "N/A"}
              // onChange={(val) => {
              //   const proceed = handleCellEdit(
              //     { label: val, value: val },
              //     index,
              //     "category",
              //     observation.category,
              //     observation
              //   );
              //   if (proceed !== false && val) {
              //     populateCheckpointList(val, "category", observation.area, observation.equipment);
              //   }
              // }}
              onSelect={(val) => {
                const proceed = handleCellEdit(
                  { label: val, value: val },
                  index,
                  "category",
                  observation.category,
                  observation
                );
                if (proceed !== false && val) {
                  populateCheckpointList(val, "category", observation.area, observation.equipment);
                }
              }}
              onFocus={() => handleEditFieldFocus(observation.sr_no, "category")}
              onBlur={() => handleEditFieldBlur(observation.sr_no, "category")}
              onMenuOpen={() => {
                setIsEditCategoryDropdownOpen(true);
              }}
              onMenuClose={() => setIsEditCategoryDropdownOpen(false)}
              menuPortalTarget={document.body}
              isDisabled={isFieldDisabled(observation) || observation.variant === true}
              containerClasses={!observation.category || !observation.category.trim() ? "error-input" : ""}
            />
          </div>
        </TableCell>

        {/* checkpoints */}
        <TableCell className="editable-cell" style={{ height: "100px" }}>
          <div
            className="cell-content"
            style={{
              color:
                isEditing &&
                  currentEditedRow !== observation.sr_no
                  ? "grey"
                  : "black",
            }}
          >
            <MultiLineCreatableSelect
              ref={editCheckpointSelectRef}
              placeholder="Check Point"
              multiline={isEditing && currentEditedRow === observation.sr_no}
              options={getCheckpointOptions(
                observation.area,
                observation.equipment,
                observation.category
              )}
              value={observation.check_points || "N/A"}
              // onChange={(val) => {
              //   const proceed = handleCellEdit(
              //     { label: val, value: val },
              //     index,
              //     "check_points",
              //     observation.check_points,
              //     observation
              //   );
              //   if (proceed !== false && val) {
              //     populateCriticalityList(val, "check_points", observation.area, observation.equipment, observation.category);
              //     populateLegalReferenceList(observation.area, observation.equipment, observation.category, val, null, null);
              //   }
              // }}
              onSelect={(val) => {
                const proceed = handleCellEdit(
                  { label: val, value: val },
                  index,
                  "check_points",
                  observation.check_points,
                  observation
                );
                if (proceed !== false && val) {
                  populateCriticalityList(val, "check_points", observation.area, observation.equipment, observation.category);
                  populateLegalReferenceList(observation.area, observation.equipment, observation.category, val, null, null);
                }
              }}
              onFocus={() => handleEditFieldFocus(observation.sr_no, "check_points")}
              onBlur={() => handleEditFieldBlur(observation.sr_no, "check_points")}
              onMenuOpen={() => {
                setIsEditCheckpointDropdownOpen(true);
              }}
              onMenuClose={() => setIsEditCheckpointDropdownOpen(false)}
              menuPortalTarget={document.body}
              isDisabled={isFieldDisabled(observation) || observation.variant === true}
              containerClasses={observation?.emptyFields?.length && observation.emptyFields.includes("Checkpoint") ? "error-input" : ""}
            />
          </div>
        </TableCell>

        {/* criticality */}
        {/* <TableCell className="editable-cell" style={{ height: "100px" }}>
                                    <Select
                                      ref={editCriticalitySelectRef}
                                      styles={{
                                        ...customSelectStylesCreatable,
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                      }}
                                      placeholder="Criticality"
                                      options={(() => {
                                        if (!observation.check_points) {
                                          return []; // No options until checkpoint is selected
                                        }
                                        const criticality = (allData?.data || [])
                                          .filter((e) => e.check_points === observation.check_points && e.area === observation.area && e.equipment === observation.equipment && e.category === observation.category)
                                          .map((e) => e.criticality);
                                        const uniqueCriticalityList = [...new Set(criticality)];
                                        const optionsToUse = uniqueCriticalityList.length > 0 ? uniqueCriticalityList : criticalityOptionList;
                                        return optionsToUse.map((criticality) => ({ label: criticality, value: criticality }));
                                      })()}
                                      noOptionsMessage={() => "No options"}
                                      value={
                                        observation.criticality
                                          ? { label: observation.criticality, value: observation.criticality }
                                          : null
                                      }
                                      isSearchable={false}
                                      isClearable
                                      onChange={(selectedOption) => {
                                        if (currentEditedRow !== -1 && currentEditedRow !== observation.sr_no) {
                                          toast.warning("Please save the current row before editing another.");
                                          return;
                                        }

                                        if (selectedOption) {
                                          const newValue = selectedOption.value;

                                          // Pass updated observation object with new criticality to handleCellEdit
                                          const proceed = handleCellEdit(
                                            { value: newValue }, // mimic the select object
                                            index,
                                            "criticality",
                                            observation.criticality,
                                            { ...observation, criticality: newValue }
                                          );

                                          if (!proceed) return;

                                          populateStatusList(observation.area, observation.equipment, observation.category, newValue);
                                        } else {
                                          // Handle clear: set criticality and dependent fields to empty
                                          handleCellEdit(
                                            { value: "" },
                                            index,
                                            "criticality",
                                            observation.criticality,
                                            { ...observation, criticality: "", status: "", observation: "", recommendations: "", legal_reference: "" }
                                          );
                                        }
                                      }}
                                      onMenuOpen={() => setIsEditCriticalityDropdownOpen(true)}
                                      onMenuClose={() => setIsEditCriticalityDropdownOpen(false)}
                                      menuPortalTarget={document.body}
                                      menuPlacement="auto"
                                      isDisabled={
                                        isFieldDisabled(observation) ||
                                        observation.variant === true
                                      }
                                    />
                                  </TableCell> */}
        {/* criticality */}
        <TableCell className="editable-cell" style={{ height: "100px" }}>
          <MultiLineCreatableSelect
            ref={editCriticalitySelectRef}
            placeholder="Criticality"
            multiline={false}
            allowCreate={false}
            options={rowDd.criticalityOpts}
            value={observation.criticality || "N/A"}
            onChange={(val) => {
              if (
                currentEditedRow !== -1 &&
                currentEditedRow !== observation.sr_no
              ) {
                toast.warning(
                  "Please save the current row before editing another."
                );
                return;
              }

              if (val) {
                const proceed = handleCellEdit(
                  { value: val },
                  index,
                  "criticality",
                  observation.criticality,
                  {
                    ...observation,
                    criticality: val,
                  }
                );

                if (!proceed) return;

                populateStatusList(
                  observation.area,
                  observation.equipment,
                  observation.category,
                  val
                );
              } else {
                handleCellEdit(
                  { value: "" },
                  index,
                  "criticality",
                  observation.criticality,
                  {
                    ...observation,
                    criticality: "",
                    status: "",
                    observation: "",
                    recommendations: "",
                    legal_reference: "",
                  }
                );
              }
            }}
            onSelect={(val) => {
              if (
                currentEditedRow !== -1 &&
                currentEditedRow !== observation.sr_no
              ) {
                return;
              }

              populateStatusList(
                observation.area,
                observation.equipment,
                observation.category,
                val
              );
            }}
            onMenuOpen={() =>
              setIsEditCriticalityDropdownOpen(true)
            }
            onMenuClose={() =>
              setIsEditCriticalityDropdownOpen(false)
            }
            menuPortalTarget={document.body}
            isDisabled={
              isFieldDisabled(observation) ||
              observation.variant === true
            }
            containerClasses={observation?.emptyFields?.length && observation.emptyFields.includes("Criticality") ? "error-input" : ""}
          />
        </TableCell>
        
        {/* Status */}
        <TableCell className="editable-cell" style={{ height: "100px" }}>
          <MultiLineCreatableSelect
            ref={editStatusSelectRef}
            placeholder="Status"
            multiline={false}
            allowCreate={false}
            options={rowDd.statusOpts}
            value={observation.status || "N/A"}
            onChange={(val) => {
              if (
                currentEditedRow !== -1 &&
                currentEditedRow !== observation.sr_no
              ) {
                toast.warning(
                  "Please save the current row before editing another."
                );
                return;
              }

              if (val) {
                const proceed = handleCellEdit(
                  { value: val },
                  index,
                  "status",
                  observation.status,
                  {
                    ...observation,
                    status: val,
                  }
                );

                if (!proceed) return;
              } else {
                handleCellEdit(
                  { value: "" },
                  index,
                  "status",
                  observation.status,
                  {
                    ...observation,
                    status: "",
                    observation: "",
                    recommendations: "",
                    legal_reference: "",
                  }
                );
              }
            }}
            onMenuOpen={() =>
              setIsEditStatusDropdownOpen(true)
            }
            onMenuClose={() =>
              setIsEditStatusDropdownOpen(false)
            }
            menuPortalTarget={document.body}
            isDisabled={
              isFieldDisabled(observation) ||
              observation.variant === true
            }
            containerClasses={observation?.emptyFields?.length && observation.emptyFields.includes("Status") ? "error-input" : ""}
          />
        </TableCell>

        {/* observation */}
        <TableCell className="editable-cell" style={{ height: "100px" }}>
          <div
            className="cell-content"
            style={{
              color:
                isEditing &&
                  currentEditedRow !== observation.sr_no
                  ? "grey"
                  : "black",
            }}
          >
            <MultiLineCreatableSelect
              placeholder="Observation"
              multiline={isEditing && currentEditedRow === observation.sr_no}
              options={rowDd.observationOpts}
              value={observation.observation || "N/A"}
              // onChange={(val) =>
              //   debouncedObservationEdit(
              //     { label: val, value: val },
              //     index,
              //     "observation",
              //     observation.observation,
              //     observation
              //   )
              // }
              onSelect={(val) =>
                debouncedObservationEdit(
                  { label: val, value: val },
                  index,
                  "observation",
                  observation.observation,
                  observation
                )
              }
              onFocus={() => handleEditFieldFocus(observation.sr_no, "observation")}
              onBlur={() => handleEditFieldBlur(observation.sr_no, "observation")}
              onMenuOpen={() => {
                setIsEditObservationDropdownOpen(true);
              }}
              onMenuClose={() => setIsEditObservationDropdownOpen(false)}
              menuPortalTarget={document.body}
              isDisabled={isFieldDisabled(observation) || observation.variant === true}
              containerClasses={!observation.observation || !observation.observation.trim() ? "error-input" : ""}
            />
            <DialogBox dialog={dialog} handleDialogBox={handleDialogBoxObservation} />
          </div>
        </TableCell>

        {/* recommendations */}
        <TableCell className="editable-cell" style={{ height: "100px" }}>
          <div
            className="cell-content"
            style={{
              color:
                isEditing &&
                  currentEditedRow !== observation.sr_no
                  ? "grey"
                  : "black",
            }}
          >
            <MultiLineCreatableSelect
              placeholder="Recommendations"
              multiline={isEditing && currentEditedRow === observation.sr_no}
              options={rowDd.recommendationOpts}
              value={observation.recommendations || "N/A"}
              // onChange={(val) =>
              //   debouncedRecommendationEdit(
              //     { label: val, value: val },
              //     index,
              //     "recommendations",
              //     observation.recommendations,
              //     observation
              //   )
              // }
              onSelect={(val) =>
                debouncedRecommendationEdit(
                  { label: val, value: val },
                  index,
                  "recommendations",
                  observation.recommendations,
                  observation
                )
              }
              onFocus={() => handleEditFieldFocus(observation.sr_no, "recommendations")}
              onBlur={() => handleEditFieldBlur(observation.sr_no, "recommendations")}
              onMenuOpen={() => setIsEditRecommendationsDropdownOpen(true)}
              onMenuClose={() => setIsEditRecommendationsDropdownOpen(false)}
              menuPortalTarget={document.body}
              isDisabled={isFieldDisabled(observation) || observation.variant === true}
              containerClasses={observation?.emptyFields?.length && observation.emptyFields.includes("Recommendations") ? "error-input" : ""}
            />
          </div>
        </TableCell>

        {/* legal reference */}
        <TableCell
          className="editable-cell"
          style={{ height: "100px" }}
        >
          <div
            className="cell-content"
            style={{
              color:
                isEditing &&
                  currentEditedRow !== observation.sr_no
                  ? "grey"
                  : "black",
            }}
          >
            <MultiLineCreatableSelect
              placeholder="Legal Reference"
              multiline={isEditing && currentEditedRow === observation.sr_no}
              options={rowDd.legalOpts}
              value={observation.legal_reference || "N/A"}
              // onChange={(val) =>
              //   debouncedLegalReferenceEdit(
              //     { label: val, value: val },
              //     index,
              //     "legal_reference",
              //     observation.legal_reference,
              //     observation
              //   )
              // }
              onSelect={(val) =>
                debouncedLegalReferenceEdit(
                  { label: val, value: val },
                  index,
                  "legal_reference",
                  observation.legal_reference,
                  observation
                )
              }
              onFocus={() => handleEditFieldFocus(observation.sr_no, "legal_reference")}
              onBlur={() => handleEditFieldBlur(observation.sr_no, "legal_reference")}
              menuPortalTarget={document.body}
              isDisabled={isFieldDisabled(observation) || observation.variant === true}
            />
          </div>
        </TableCell>

        {/* Max Points */}
        <TableCell className="editable-cell" style={{ height: "100px" }}>
          <div className="cell-content">
            <MultiLineCreatableSelect
              placeholder="Max Points"
              multiline={false}
              allowCreate={false}
              isScoring={true}
              value={observation?.max_pts ?? 0}
              isDisabled={true}
            />
          </div>
        </TableCell>

        {/* scores */}
        <TableCell className="editable-cell" style={{ height: "100px" }}>
          <div
            className="cell-content"
            style={{
              marginRight: "10px",
            }}
          >
            <MultiLineCreatableSelect
              multiline={false}
              allowCreate={false}
              isScoring={true}
              value={observation.score ?? 0}
              placeholder="Score"
              isDisabled={true}
            />
          </div>
        </TableCell>
        {/* system_implentation */}
        {/* <TableCell className="editable-cell">
                                    <div
                                      className="cell-content"
                                      style={{

                                        marginRight: "10px"
                                      }}
                                    >

                                      <TextField
                                        id={`outlined-textarea-${index}`}
                                        value={observation.system_implementation}
                                        placeholder="System Implementation"
                                        onChange={(e) => {
                                          const newValue = e.target.value;

                                          const proceed = handleCellEdit(
                                            { ...e, target: { ...e.target, textContent: newValue } },
                                            index,
                                            "system_implementation",
                                            observation.system_implementation,
                                            { ...observation, system_implementation: newValue }
                                          );

                                          if (!proceed) return;

                                          setSelectedObservations((prev) =>
                                            prev.map((obs) =>
                                              (obs.sr_no || obs.id) === (observation.sr_no || observation.id)
                                                ? { ...obs, system_implementation: newValue, hasEdited: true }
                                                : obs
                                            )
                                          );
                                        }}
                                        onBlur={(e) => {
                                          const latestValue = e.target.value;

                                          handleCellEdit(
                                            { ...e, target: { ...e.target, textContent: latestValue } },
                                            index,
                                            "system_implementation",
                                            observation.system_implementation,
                                            { ...observation, system_implementation: latestValue }
                                          );
                                        }}
                                        sx={{ width: "200px" }}
                                        InputProps={{
                                          sx: { fontSize: "10px" },
                                          disabled: currentEditedRow !== -1 && currentEditedRow !== observation.sr_no,
                                        }}
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        multiline
                                        minRows={1.5}
                                        maxRows={10}
                                      />


                                    </div>
                                    {!observation.variant && !observation.isNew && (
                                      <EditOutlinedIcon
                                        onClick={(e) =>
                                          isEditing
                                            ? handleCellEdit(
                                              e,
                                              index,
                                              "system_implementation",
                                              observation.system_implementation,
                                              observation
                                            )
                                            : null
                                        }
                                        className="edit-icon"
                                        fontSize="small"
                                      />
                                    )}
                                  </TableCell>}
                                  {/* compliance_check */}
        {/* <TableCell className="editable-cell">
                                    <div
                                      className="cell-content"
                                      style={{

                                        marginRight: "10px"
                                      }}
                                    >

                                      <TextField
                                        id={`outlined-textarea-${index}`}
                                        value={observation.compliance_check}
                                        placeholder="Compliance Check"
                                        onChange={(e) => {
                                          const newValue = e.target.value;

                                          const proceed = handleCellEdit(
                                            { ...e, target: { ...e.target, textContent: newValue } },
                                            index,
                                            "compliance_check",
                                            observation.compliance_check,
                                            { ...observation, compliance_check: newValue }
                                          );

                                          if (!proceed) return;

                                          setSelectedObservations((prev) =>
                                            prev.map((obs) =>
                                              (obs.sr_no || obs.id) === (observation.sr_no || observation.id)
                                                ? { ...obs, compliance_check: newValue, hasEdited: true }
                                                : obs
                                            )
                                          );
                                        }}
                                        onBlur={(e) => {
                                          const latestValue = e.target.value;

                                          handleCellEdit(
                                            { ...e, target: { ...e.target, textContent: latestValue } },
                                            index,
                                            "compliance_check",
                                            observation.compliance_check,
                                            { ...observation, compliance_check: latestValue }
                                          );
                                        }}
                                        sx={{ width: "200px" }}
                                        InputProps={{
                                          sx: { fontSize: "10px" },
                                          disabled: currentEditedRow !== -1 && currentEditedRow !== observation.sr_no,
                                        }}
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        multiline
                                        minRows={1.5}
                                        maxRows={10}
                                      />


                                    </div>
                                    {!observation.variant && (
                                      <EditOutlinedIcon
                                        onClick={(e) =>
                                          isEditing
                                            ? handleCellEdit(
                                              e,
                                              index,
                                              "compliance_check",
                                              observation.compliance_check,
                                              observation
                                            )
                                            : null
                                        }
                                        className="edit-icon"
                                        fontSize="small"
                                      />
                                    )}
                                  </TableCell> */}
        {/* image upload */}
        <TableCell>
          
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "15px",
            }}
          >
            {/* Open Gallery only when this row is the one being edited */}
            {!isFieldDisabled(observation) ?
              bulkUploadedImages.length > 0 || observation?.imageUrls?.length > 0 ?
                <Tooltip title="Open Gallery" placement="top">
                  <div
                    onClick={() => handleOpenGallery(tableType, observation)}
                    style={{
                        padding: "6px 0px",
                        border: "1px solid grey",
                        borderRadius: "5px",
                        width: "100px",
                        justifyContent: "center",
                        alignItems:"center",
                        display:"flex",
                      }}>
                    <AddPhotoAlternateOutlined fontSize="30" />
                  </div>
                </Tooltip>
                :
                <Tooltip key={index} title="click here to go to  Bulk Upload" placement="top">
                  <span
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      // Can't move the real cursor (browsers block that) — scroll
                      // to top and flash a highlight instead.
                      const el = document.querySelector(".bulk-upload-zone");
                      if (!el) return;
                      el.scrollIntoView({ behavior: "smooth", block: "center" });
                      el.style.transition = "box-shadow 0.3s ease";
                      el.style.boxShadow = "0 0 0 3px #1976d2";
                      setTimeout(() => {
                        el.style.boxShadow = "none";
                      }, 1500);
                    }}
                  >
                    Please Upload images
                  </span>
                </Tooltip>
              :
              observation?.imageUrls?.length > 0 ?
                <Tooltip title="View Images" placement="top">
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      padding: "6px 0",
                      border: "1px solid grey",
                      borderRadius: "5px",
                      width: "100px",
                      cursor: "pointer",
                      background: "white",
                      opacity: 1,
                    }}
                    onClick={() =>
                      handleOpenImageDialog(observation.sr_no || observation.id, observation)
                    }
                  >
                    <InsertPhotoOutlinedIcon size={30} />
                  </div>
                </Tooltip>
                :
                <Tooltip title="click here to go to  Bulk Upload" placement="top">
                  <span
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      // Can't move the real cursor (browsers block that) — scroll
                      // to top and flash a highlight instead.
                      const el = document.querySelector(".bulk-upload-zone");
                      if (!el) return;
                      el.scrollIntoView({ behavior: "smooth", block: "center" });
                      el.style.transition = "box-shadow 0.3s ease";
                      el.style.boxShadow = "0 0 0 3px #1976d2";
                      setTimeout(() => {
                        el.style.boxShadow = "none";
                      }, 1500);
                    }}
                  >
                    No images uploaded
                  </span>
                </Tooltip>
            }
            
            {/* <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "6px 0",
                border: "1px solid grey",
                borderRadius: "5px",
                width: "100px",
                cursor: isFieldDisabled(observation)
                  ? "not-allowed"
                  : "pointer",
                position: "relative",
                background: isFieldDisabled(observation)
                  ? "#f0f0f0"
                  : "white",
                opacity: isFieldDisabled(observation)
                  ? 0.6
                  : 1,
              }}
            >
              <CloudUploadOutlinedIcon size={30} />
              <input
                type="file"
                accept="image/jpeg,image/png"
                multiple
                onChange={(e) =>
                  handleImageUpload(
                    observation.table_type,
                    observation.sr_no || observation.id,
                    observation.area,
                    e.target.files
                  )
                }
                style={{
                  position: "absolute",
                  width: "100%",
                  height: "100%",
                  top: 0,
                  left: 0,
                  opacity: 0,
                  cursor: isFieldDisabled(observation)
                    ? "not-allowed"
                    : "pointer",
                }}
                disabled={isFieldDisabled(observation)}
              />
            </div> */}

            
          </div>

          {selectedObservation?.image &&
            selectedObservation.image.sr_no === observation.sr_no && (
              <Dialog onClose={handleCloseImageDialog} open={openDialog} maxWidth={false}
                PaperProps={{
                  sx: {
                    border: "1px solid black",
                    borderRadius: "10px",
                  },
                }}
              >
                <DialogTitle>Uploaded Images</DialogTitle>
                <DialogContent dividers>
                  {selectedObservation.image.imageUrls?.length > 0 ? (
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(4, 1fr)",
                        gap: "10px",
                      }}
                    >
                      {selectedObservation.image.imageUrls.map(
                        (imageUrl, imgIndex) => (
                          <div style={{ display: "flex" }} key={imgIndex}>
                            <img
                              src={imageUrl}
                              alt={`Image ${imgIndex + 1}`}
                              onClick={() => setSelectedImage(imageUrl)}
                              style={{
                                cursor: "pointer",
                                width: "200px",
                                height: "200px",
                                objectFit: "cover",
                                borderRadius: "4px",
                                border:'1px solid'
                              }}
                            />
                            {(currentEditedRow === selectedObservation?.image?.sr_no) ? <CancelIcon
                              className="cancel-icon"
                              onClick={() =>
                                handleRemoveImage(
                                  observation.table_type,
                                  observation.area,
                                  observation.sr_no || observation.id,
                                  imgIndex
                                )
                              }
                              style={{ cursor: "pointer", marginLeft: 5 }}
                            />
                              : null
                            }
                          </div>
                        )
                      )}
                    </div>
                  ) : (
                    <Typography gutterBottom>No File Uploaded</Typography>
                  )}
                </DialogContent>
                <DialogActions>
                  <Button onClick={handleCloseImageDialog}>Close</Button>
                </DialogActions>
              </Dialog>
            )}
        </TableCell>
        {/* Info */}
        <TableCell className="table-actions">
          <div
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <InfoIcon
              onClick={() =>
                getObservationVariants(observation.observation, observation.sr_no || observation.id)
              }
              style={{
                pointerEvents: (() => {
                  const matchingObservation = selectedObservations.find(
                    (obs) =>
                      obs.table_type === observation.table_type &&
                      obs.area === observation.area &&
                      (obs.sr_no === observation.sr_no || obs.id === observation.id)
                  );

                  return isEditing &&
                    (!matchingObservation ||
                      (matchingObservation.sr_no !== observation.sr_no &&
                        matchingObservation.id !== observation.id))
                    ? "none"
                    : "auto";
                })(),
              }}
            />
            {/* Edit/Save Toggle Icon */}
            {isEditing && currentEditedRow === observation.sr_no ? (
              <CheckIcon
                onClick={() => {
                  console.log('-- CheckIcon click')
                  const missingFields = handleEmptyCheck(observation, tableType);
                  if (missingFields?.length > 0 && emptyFieldFound) {
                    // Validation failed — exit immediately, do not save.
                    return;
                  }
                  handleSaveRowBatch(observation, tableType);
                }}
                style={{
                  cursor: "pointer",
                  color: "green",
                  marginLeft: "8px",
                  marginRight: "8px",
                }}
                titleAccess="Save changes and exit edit mode"
              />
            ) : (
              <EditOutlinedIcon
                onClick={() => {
                  if (observation.isNew) {
                    handleEditNewRow(observation);
                  } else {
                    if (isEditing && currentEditedRow !== -1 && currentEditedRow !== observation.sr_no) {
                      const unsavedRow = selectedObservations.find(
                        (obs) => obs.sr_no === currentEditedRow || obs.id === currentEditedRow
                      );
                      const unsavedTableType = unsavedRow?.table_type || "another table";
                      const unsavedRowIndex = safeGroupedObservations[unsavedTableType]
                        ? safeGroupedObservations[unsavedTableType].findIndex(
                          (obs) => obs.sr_no === currentEditedRow || obs.id === currentEditedRow
                        )
                        : -1;
                      const unsavedSrNo = unsavedRowIndex !== -1 ? unsavedRowIndex + 1 : null;

                      toast.warning(
                        unsavedSrNo
                          ? `You have an unsaved observation at row ${unsavedSrNo} in "${unsavedTableType}". Please save it before editing another row.`
                          : `You have an unsaved observation row in "${unsavedTableType}". Please save it before editing another row.`
                      );
                      return;
                    }
                    setIsEditing(true);
                    setCurrentEditedRow(observation.sr_no);
                    setIsReportEdited(true);
                  }
                }}
                style={{
                  cursor: (isEditing && currentEditedRow !== -1 && currentEditedRow !== observation.sr_no)
                    ? "not-allowed"
                    : "pointer",
                  color: (isEditing && currentEditedRow !== -1 && currentEditedRow !== observation.sr_no)
                    ? "grey"
                    : "#1976d2",
                  marginLeft: "8px",
                  marginRight: "8px",
                }}
                titleAccess="Edit row"
              />
            )}
            {/* <PlaylistAddCircleIcon
                                        onClick={() =>
                                          handleDuplicateRow(
                                            observation.table_type,
                                            observation.area,
                                            observation.sr_no || observation.id
                                          )
                                        }
                                        style={{
                                          pointerEvents: (() => {
                                            const matchingObservation = selectedObservations.find(
                                              (obs) =>
                                                obs.table_type === observation.table_type &&
                                                obs.area === observation.area &&
                                                (obs.sr_no === observation.sr_no || obs.id === observation.id)
                                            );

                                            return isEditing &&
                                              (!matchingObservation ||
                                                (matchingObservation.sr_no !== observation.sr_no &&
                                                  matchingObservation.id !== observation.id))
                                              ? "none"
                                              : "auto";
                                          })(),
                                        }}
                                      /> */}
            <DeleteForeverIcon
              onClick={() => {
                if (!window.confirm("Are you sure you want to delete this observation?")) return;
                handleDeleteRow(
                  observation.table_type,
                  observation.area,
                  observation.sr_no || observation.id
                );
              }}
              style={{
                pointerEvents: (() => {
                  const matchingObservation = selectedObservations.find(
                    (obs) =>
                      obs.table_type === observation.table_type &&
                      obs.area === observation.area &&
                      (obs.sr_no === observation.sr_no || obs.id === observation.id)
                  );

                  return isEditing &&
                    (!matchingObservation ||
                      (matchingObservation.sr_no !== observation.sr_no &&
                        matchingObservation.id !== observation.id))
                    ? "none"
                    : "auto";
                })(),
              }}
            />
          </div>
        </TableCell>

      </TableRow>
    );
  },
  (prevProps, nextProps) => {
    const o1 = prevProps.observation;
    const o2 = nextProps.observation;
    if (
      o1.sr_no !== o2.sr_no ||
      o1.id !== o2.id ||
      o1.area !== o2.area ||
      o1.equipment !== o2.equipment ||
      o1.category !== o2.category ||
      o1.check_points !== o2.check_points ||
      o1.criticality !== o2.criticality ||
      o1.status !== o2.status ||
      o1.observation !== o2.observation ||
      o1.recommendations !== o2.recommendations ||
      o1.legal_reference !== o2.legal_reference ||
      o1.max_pts !== o2.max_pts ||
      o1.score !== o2.score ||
      o1.variant !== o2.variant ||
      o1.isNew !== o2.isNew ||
      o1.image !== o2.image
    ) {
      return false;
    }
    // emptyFields isn't covered by the field checks above. Without this, the
    // empty-field highlight set by handleEmptyCheck/handleSaveRowBatch never
    // shows up because the field checks above all still match.
    const ef1 = o1.emptyFields || [];
    const ef2 = o2.emptyFields || [];
    if (ef1.length !== ef2.length || ef1.some((v, i) => v !== ef2[i])) {
      return false;
    }
    // imageUrls isn't covered by the field checks above. Without this, uploading
    // (or removing) an image doesn't re-render the row, so the preview dialog's
    // onClick captures a stale observation and shows the wrong image list until
    // a later render. Compare length + contents so add/remove both trigger a render.
    const u1 = o1.imageUrls || [];
    const u2 = o2.imageUrls || [];
    if (u1.length !== u2.length || u1.some((v, i) => v !== u2[i])) {
      return false;
    }
    // bulkUploadedImages isn't covered above either — without this, pushing
    // new images from the gallery doesn't re-render the row.
    const b1 = prevProps.bulkUploadedImages || [];
    const b2 = nextProps.bulkUploadedImages || [];
    if (b1.length !== b2.length || b1.some((v, i) => v !== b2[i])) {
      return false;
    }
    if (prevProps.rowDd !== nextProps.rowDd) return false;
    if (prevProps.index !== nextProps.index) return false;
    if (prevProps.tableType !== nextProps.tableType) return false;
    if (prevProps.isEditing !== nextProps.isEditing) return false;
    if (prevProps.isRowInSelected !== nextProps.isRowInSelected) return false;
    const wasEdited =
      prevProps.currentEditedRow === o1.sr_no || prevProps.currentEditedRow === o1.id;
    const isEdited =
      nextProps.currentEditedRow === o2.sr_no || nextProps.currentEditedRow === o2.id;
    if (wasEdited !== isEdited) return false;
    const thisRowDialog =
      nextProps.selectedObservation?.image?.sr_no === o2.sr_no ||
      prevProps.selectedObservation?.image?.sr_no === o1.sr_no;
    if (
      thisRowDialog &&
      (prevProps.openDialog !== nextProps.openDialog ||
        prevProps.dialog !== nextProps.dialog ||
        prevProps.selectedObservation !== nextProps.selectedObservation)
    ) {
      return false;
    }
    return true;
  }
);

HseObservationRow.displayName = 'HseObservationRow';

export default HseObservationRow;
